import React from 'react'
import styled from 'styled-components'
import { times } from '../../lib/ramda'
import { StarIcon } from '../Icon/StarIcon'
import { STYLES } from '../../static/style'

type RatingProps = {
  rating?: number
}

const RatingContainer = styled.div`
  color: ${STYLES.PRIMARY_COLOR};
  display: flex;
`

const StyledStarIcon = styled(StarIcon)`
  font-size: 0.85rem;
`

const Rating = ({ rating = 5 }: RatingProps) => (
  <RatingContainer>
    {times(
      (n) => (
        <StyledStarIcon key={n} />
      ),
      rating
    )}
  </RatingContainer>
)

export { Rating }
